var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('ZonalColumnChart',{attrs:{"controlPanelProps":_vm.controlPanelProps,"colors":_vm.regionalColor}})],1),_c('div',{staticClass:"col-md-4"},[_c('ZonalMap',{attrs:{"controlPanelProps":_vm.controlPanelProps,"colors":_vm.regionalColor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }